import React from "react";

const Container = (props) => {
  return <div className="px-md-5">{props.children}</div>;
};

export default Container;
